var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.367188 8.568C0.367188 5.56892 0.367188 4.06938 0.950848 2.92388C1.46425 1.91627 2.28346 1.09706 3.29107 0.58366C4.43657 0 5.93611 0 8.93519 0H16.4322C19.4313 0 20.9308 0 22.0763 0.58366C23.0839 1.09706 23.9031 1.91627 24.4165 2.92388C25.0002 4.06938 25.0002 5.56892 25.0002 8.568V16.065C25.0002 19.0641 25.0002 20.5636 24.4165 21.7091C23.9031 22.7167 23.0839 23.5359 22.0763 24.0493C20.9308 24.633 19.4313 24.633 16.4322 24.633H8.93519C5.93611 24.633 4.43657 24.633 3.29107 24.0493C2.28346 23.5359 1.46425 22.7167 0.950848 21.7091C0.367188 20.5636 0.367188 19.0641 0.367188 16.065V8.568Z",
    fill: "#0A1E4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4258 17.9613C10.7337 17.9613 10.8697 17.8205 11.0416 17.6534L12.6838 16.0565L10.6354 14.8213",
    fill: "#B4BCC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6356 14.8217L15.5992 18.4888C16.1656 18.8014 16.5743 18.6395 16.7155 17.963L18.7359 8.44207C18.9427 7.61276 18.4198 7.23649 17.8778 7.48251L6.01397 12.0572C5.20416 12.382 5.20899 12.8338 5.86638 13.0351L8.91092 13.9854L15.9593 9.53865C16.2921 9.33687 16.5975 9.44525 16.3469 9.66777",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.95f6312dd8998352ef5fcf23ae1040ba.svg";
export { ForwardRef as ReactComponent };